module.exports = __webpack_public_path__ + "img/icon-chevron-right-grey.be2dbdef.svg";